import api from "./api";
import { normalizePokemonRef } from "../utils/pokemon";

const pokemonCache = new Map();
const pendingPokemonRequests = new Map();

export async function fetchPokemonList(pageUrl) {
  const { data } = await api.get(pageUrl);

  return {
    results: data.results,
    next: data.next,
    previous: data.previous,
  };
}

export async function fetchPokemon(pokemonRef) {
  const normalizedPokemon = normalizePokemonRef(pokemonRef);

  if (!normalizedPokemon) {
    throw new Error("Pokemon ref is required");
  }

  if (pokemonCache.has(normalizedPokemon)) {
    return pokemonCache.get(normalizedPokemon);
  }

  if (pendingPokemonRequests.has(normalizedPokemon)) {
    return pendingPokemonRequests.get(normalizedPokemon);
  }

  const request = api
    .get(normalizedPokemon)
    .then(({ data }) => {
      pokemonCache.set(normalizedPokemon, data);
      return data;
    })
    .finally(() => {
      pendingPokemonRequests.delete(normalizedPokemon);
    });

  pendingPokemonRequests.set(normalizedPokemon, request);

  return request;
}

export function clearPokemonCache() {
  pokemonCache.clear();
  pendingPokemonRequests.clear();
}
